import { IApplicationState } from '../../types/redux';

export function getBrochure(state: IApplicationState) {
  return state.newbuilding.brochure;
}
